export default __webpack_public_path__ + "images/rango-fixed-icon-1_168c2a.svg";